import request from './request';

export function getSurveyDetail(hospId, surveyId) {
    return request.get('/api/survey/getSurveyDetail', {
        params: {
            hospid: hospId,
            surveyId,
        }
    });
}

export function getSurveyInfo(hospId) {
    return request.get('/api/survey/getSurveyInfo', {
        params: {
            hospid: hospId
        }
    });
}

export function saveUserSurvey(data) {
    return request.post('/api/survey/saveSurvey', data);
}

export function getUserSurveys() {
    return request.get('/api/survey/UserSurveys');
}

export function getUserSurveyDetail(id) {
    return request.get('/api/survey/SurveyDetail', {
        params: {
            id: id
        }
    });
}

export function checkUserSurvey(hospId, profileId) {
    return request.post('/api/survey/checkUserSurvey', {
        hospId,
        profileId,
    });
}